import script from "./RangeExplorerTab.vue?vue&type=script&setup=true&lang=js"
export * from "./RangeExplorerTab.vue?vue&type=script&setup=true&lang=js"

import "./RangeExplorerTab.vue?vue&type=style&index=0&id=5a42ff27&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a42ff27"]])

export default __exports__